export default __webpack_public_path__ + "static/media/Convit-Z-200-ml-ban.44aa2437.jpg";